import type { Locale } from "@commerce-frontend/i18n/types";
import { storyblokDataAttributes } from "@commerce-frontend/storyblok-preview/component";
import { type ThreeColumnFragmentFragment, graphql } from "@commerce-frontend/types";
import { cn } from "@commerce-frontend/ui/helpers/styles";
import type { HTMLAttributes } from "react";
import { Column, columnVariants } from "./Column";

graphql(/* GraphQL */ `
	fragment ThreeColumnFragment on ThreeColumns {
		__typename
		id
		alignment
		column_1 {
			...ColumnBlockFragment
		}
		column_2 {
			...ColumnBlockFragment
		}
		column_3 {
			...ColumnBlockFragment
		}
	}
`);

type Props = {
	data: ThreeColumnFragmentFragment;
	locale: Locale;
} & HTMLAttributes<HTMLDivElement>;

export const ThreeColumns = ({ data, locale, ...attributes }: Props) => {
	const { alignment, column_1, column_2, column_3 } = data;

	return (
		<div
			className={cn(columnVariants({ alignment }), attributes.className)}
			{...storyblokDataAttributes(data)}
		>
			{[column_1, column_2, column_3].map((column, index) => (
				<Column key={index} data={column} locale={locale} />
			))}
		</div>
	);
};
